export default __webpack_public_path__ + "82b599ff94894c0474268a1c3024524a.png";